import { filterMonthTitle } from "../../pages/super-admin-dashboard/filterMonthTitle";

const getCurrentMonthInput = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
};

export const getDashboardMonthContext = (selectedMonthYear) => {
  const hasMonthFilter = Boolean(selectedMonthYear);
  const activeMonthInput = hasMonthFilter ? selectedMonthYear : getCurrentMonthInput();

  return {
    hasMonthFilter,
    monthLabel: filterMonthTitle(activeMonthInput),
  };
};

export const buildMonthAwareLabel = ({
  hasMonthFilter,
  monthLabel,
  defaultLabel,
  filteredLabel = defaultLabel,
  showMonthWhenUnfiltered = false,
  showMonthWhenFiltered = true,
}) => {
  const baseLabel = hasMonthFilter ? filteredLabel : defaultLabel;
  const shouldShowMonth = hasMonthFilter ? showMonthWhenFiltered : showMonthWhenUnfiltered;

  if (!shouldShowMonth || !monthLabel) {
    return baseLabel;
  }

  return `${baseLabel} (${monthLabel})`;
};

export const buildMonthAwareTitle = ({
  hasMonthFilter,
  monthLabel,
  defaultLabel,
  filteredLabel = defaultLabel,
  showMonthWhenUnfiltered = false,
  showMonthWhenFiltered = true,
  monthClassName,
  monthPrefix = "",
}) => {
  const label = hasMonthFilter ? filteredLabel : defaultLabel;
  const showMonth = hasMonthFilter ? showMonthWhenFiltered : showMonthWhenUnfiltered;

  if (!showMonth || !monthLabel) {
    return label;
  }

  const monthText = monthPrefix && hasMonthFilter ? `${monthPrefix} ${monthLabel}` : monthLabel;
  return (
    <>
      {label} <span className={monthClassName}>({monthText})</span>
    </>
  );
};